import type { SupabaseClient } from "@supabase/supabase-js";

export async function signUpWithPassword({
  supabase,
  email,
  password,
}: {
  supabase: SupabaseClient;
  email: string;
  password: string;
}): Promise<void> {
  const { data, error } = await supabase.auth.signUp({
    email: email.trim(),
    password,
  });

  if (error) {
    throw new Error(error.message);
  }

  if (!data.session) {
    throw new Error(
      "Account created but no session was returned. Check that email confirmation is disabled in your Supabase project.",
    );
  }
}

export async function signInWithPassword({
  supabase,
  email,
  password,
}: {
  supabase: SupabaseClient;
  email: string;
  password: string;
}): Promise<void> {
  const { data, error } = await supabase.auth.signInWithPassword({
    email: email.trim(),
    password,
  });

  if (error) {
    throw new Error(error.message);
  }

  if (!data.session) {
    throw new Error("Sign-in succeeded but no session was returned.");
  }
}
